<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import store from "@/store";

export default {
  name: "dataAnalysisRecord",
  components: { breadcrumbs },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        }
      },
      form: {
        startTime: null,
        endTime: null,
        companyId: null
      },
      stateForm: {}
    };
  },
  computed: {},
  methods: {
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    search() {
      this.$refs.customTable.loadData();
    },
    reset() {
      this.form.startTime = null;
      this.form.endTime = null;
      this.search();
    },
    download(row) {},
    async go(row) {
      try {
        await this.$api.dataAnalysis.updateReadStatus({
          id: row.id
        });
      } catch (error) {}
      this.$router.push({
        path: "/dataAnalysis/dataAnalysisDetail?detail=" + JSON.stringify(row)
      });
    },
    getROLE() {
      var token = store.getters.get_token;
      if (token) {
        this.form.companyId = token.companyId;
      }
    }
  },
  created() {
    this.getROLE();
  },
  mounted() {}
};
</script>

<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 返回按钮 -->
    <div
      class="topReturnLink w60 fw-600 color0063ea f16 pdb-10 cursor"
      @click="$router.back()"
    >
      <i class="el-icon-arrow-left fw-600"></i>
      返回
    </div>
    <div class="pdt-15 pdb-0 bg-white">
      <el-form ref="form" :model="form" label-width="120px" inline>
        <el-form-item label="报告生成时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset">重 置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <customTable class="pdt-15" ref="customTable" :api="$api.dataAnalysis.list" :params="form">
      <template #columns>
        <el-table-column
          type="index"
          :index="indexMethod"
          label="序号"
          width="50"
          fixed="left"
        >
        </el-table-column>
        <el-table-column prop="tradeNo" label="订单编号"></el-table-column>

        <el-table-column
          prop="payPrice"
          label="数据分析单价（元）"
        ></el-table-column>

        <el-table-column prop="isSuccess" label="报告生成状态">
          <template #default="{row}">
            <span class="default" v-if="row.isSuccess === 0">生成中</span>
            <span class="success" v-else-if="row.isSuccess === 1">成功</span>
            <span class="danger" v-else-if="row.isSuccess === 2">失败</span>
          </template>
        </el-table-column>
        <el-table-column prop="userName" label="支付状态">
          <template #default="{row}">
            <span class="danger" v-if="row.status === 0">未支付</span>
            <span class="success" v-else-if="row.status === 1">已支付</span>
            <span class="default" v-else-if="row.status === 2">已退款</span>
          </template>
        </el-table-column>
        <el-table-column prop="tradeTime" label="交易时间"></el-table-column>
        <el-table-column fixed="right" label="操作" width="120">
          <template #default="{row}">
            <el-button v-if="row.url" type="text" size="small" @click="go(row)"
              >预览
            </el-button>
            <el-button
              v-if="row.url"
              type="text"
              size="small"
              @click="download(row)"
              >下载
            </el-button>
          </template>
        </el-table-column>
      </template></customTable
    >
  </div>
</template>

<style scoped lang="scss">
.success {
  color: #67c23a;
}
.danger {
  color: var(--danger);
}
.default {
  color: var(--accent);
}
.container {
  .infinite-list-wrapper {
    height: 560px;
  }
  @keyframes skeleton-loading {
    0% {
      background-position: 100% 50%;
    }

    100% {
      background-position: 0 50%;
    }
  }
  .list {
    .list-item {
      height: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 20px;
      padding: 20px 10px;
      border-radius: 8px;
      transition: all ease-in-out 0.4s;
      cursor: pointer;
      &:hover {
        background: var(--card-bg);
      }
      .left {
        display: flex;
        align-items: center;
        .ico {
          width: 20px;
        }
        .name {
          margin-left: 20px;
          font-size: 20px;
          font-weight: bold;
        }
      }
      .right {
        display: flex;
        align-items: center;
        .time {
          margin-right: 20px;
        }
        .arrow {
          font-size: 24px;
          font-weight: bold;
        }
      }
    }
  }
  .skeleton {
    & > .li {
      margin-top: 14px;
      width: 100%;
      height: 16px;
      border-radius: 4px;
      background: linear-gradient(
        90deg,
        #0000000f 25%,
        #00000026 37%,
        #0000000f 63%
      );
      background-size: 400% 100%;
      list-style: none;
      -webkit-animation-name: skeleton-loading;
      animation-name: skeleton-loading;
      -webkit-animation-duration: 1.4s;
      animation-duration: 1.4s;
      -webkit-animation-timing-function: ease;
      animation-timing-function: ease;
      -webkit-animation-iteration-count: infinite;
      animation-iteration-count: infinite;
    }
  }
  .noMore {
    &_tip {
      margin-right: 10px;
      color: rgb(226, 226, 226);
      font-size: 20px;
    }
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
